/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"

import Header from "./header"
import "./layout.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header class="text-center"  siteTitle={data.site.siteMetadata.title} />
        <main>{children}</main>
        <div class="col-12 bg-light text-center fixed-top">
<Link to="/">BOOSTERPOS</Link>
  </div>
  <div class="masthead-followup row m-0"> 
  <div class="col-12 col-md-12 p-3 p-md-5 bg-light text-center border border-white">
    <h3>Menu.</h3>
    <Link title="aplikasi retail toko shop" to="/retail">
Retail
</Link> &nbsp;
 <Link title="aplikasi kuliner makanan minuman" to="/kuliner">
Kuliner
</Link>
    </div>
  <div class="col-12 col-md-4 p-3 p-md-5 bg-light text-left border border-white">
  <ul>App<hr/>
  <li>
    <Link title="aplikasi toko aplikasi kasir" to="/toko">
      App Toko
      </Link>
  </li>
  <li>
  <Link title="aplikasi restoran cafe rumah makan" to="/resto">
App Resto
</Link>
</li>
<li>
<Link title="aplikasi office invoice online" to="/office">
App Office
</Link>
</li>
</ul>
</div>
<div class="col-12 col-md-4 p-3 p-md-5 bg-light text-left border border-white">
<ul>POS<hr/>
  <li>
  <Link title="mesin kasir hybrid tablet pos" to="/hybrid">
Hybrid
</Link>
  </li>
  <li>
  <Link title="mesin kasir portable" to="/portable">
Portable
</Link>
</li>
<li>
<Link title="mesin kasir touchscreen" to="/touchscreen">
Touchscreen
</Link>
</li>
</ul>
</div>
<div class="col-12 col-md-4 p-3 p-md-5 bg-light text-left border border-white">
<ul>Contact<hr/>
  <li>
    <a title="chat via whatsapp" href="https://wa.me/6285646104747" target="blank" rel="nofollow">
Chat
</a>
  </li>
  <li>
  <a title="call us now" href="tel:+6285331361404" target="blank" rel="nofollow">
Call
</a>
</li>
<li>
<a title="sent email now" href="mailto:hockeycorpmarketing@gmail.com" target="blank" rel="nofollow">
Email
</a>
</li>
</ul>
</div>
</div>
        <footer class="text-center bg-light border boder-white"><small><small><small><small>
          © <a title="aplikasi mesin kasir online" href="https://boosterpos.web.app">boosterpos.web.app</a> by 
          {` `}
          <a href="https://www.gatsbyjs.org" target="blank">Gatsby</a> <a href="https://gatsbyart.web.app" target="blank">ART</a>
          </small></small></small></small></footer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
